export default {
  props: ['day', 'state', 'adjacent', 'events'],
  data: function () {
    return {
      mouseOverDay: false,
      mouseOverEvent: false
    };
  },
  methods: {
    Delay: function (callback) {
      setTimeout(callback, 0);
    }
  }
};